// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  workspaceId: __t.option(__t.u64()),
  orgId: __t.option(__t.u64()),
  scope: __t.string(),
  claim: __t.string(),
  taskTagsJson: __t.string(),
  evidenceRefsJson: __t.string(),
  aggregateCount: __t.u32(),
  confidence: __t.f32(),
  visibility: __t.string(),
  createdByAgentId: __t.option(__t.u64()),
  revisitAt: __t.option(__t.i64()),
};
